export default __webpack_public_path__ + "static/media/star_wars_lego_sets.4ff90f5c.png";